import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e98f22e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-form__col game-form__right-row" }
const _hoisted_2 = {
  ref: "convertedCountdown",
  class: "styled-text"
}
const _hoisted_3 = ["disabled"]

import { onMounted, ref, watchEffect } from 'vue';
import PromptTextArea from '@/features/PromptTextArea.vue';
import {
  GameStatus,
  useGameStore,
  RoundStatus,
  currentRequests,
  MAX_CONCURRENT_REQUESTS,
  remainingTime
} from '@/stores/gameStore';
import Vue3autocounter from 'vue3-autocounter';
import IconComponent from '@/components/IconComponent.vue';
import IconMagicWand from '@/assets/VueIcons/IconMagicWand.vue';
import { isPhone } from '@/utils/responsiveHelper';
import { updateCurrentRequests } from '@/utils/utilizatioHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromptInputForm',
  emits: ['GameForm:promptSubmitted', 'formMounted'],
  setup(__props, { emit: __emit }) {

const currentRoundCountdown = ref(null);

const gameStore = useGameStore();
const emit = __emit;

function roundCountdownExpired() {
  remainingTime.value = 0;
  gameStore.roundStatus = RoundStatus.EXPIRED;
  currentRoundCountdown.value?.reset();
}

function handlePrompt() {
  updateCurrentRequests();
  if (currentRequests.value >= MAX_CONCURRENT_REQUESTS) {
    currentRoundCountdown.value.pause();
    remainingTime.value = currentRoundCountdown.value.$data.currentAmount;
    gameStore.roundStatus = RoundStatus.INITIAL;
  }
  if (gameStore.userInput != '') {
    remainingTime.value = currentRoundCountdown.value.$data.currentAmount;
    emit('GameForm:promptSubmitted');
  }
}

watchEffect(() => {
  if (!currentRoundCountdown.value) {
    return;
  }
  if (gameStore.roundStatus === RoundStatus.SUBMITTED) {
    currentRoundCountdown.value.pause();
  } else if (gameStore.roundStatus === RoundStatus.RUNNING) {
    currentRoundCountdown.value.resume();
  }
});

onMounted(() => {
  if (gameStore.roundStatus === RoundStatus.INITIAL) {
    window.setTimeout(() => {
      gameStore.roundStatus = RoundStatus.RUNNING;

      if (currentRoundCountdown.value) {
        currentRoundCountdown.value?.reset();
        currentRoundCountdown.value?.start();
      }
    }, 2000);
  }
  emit('formMounted');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "game-form__container",
    onSubmit: _withModifiers(handlePrompt, ["prevent"])
  }, [
    _createVNode(PromptTextArea, {
      class: _normalizeClass(["game-form__col", { 'shake-animation': _unref(gameStore).shakeTrigger }]),
      "onTextArea:triggerSubmit": handlePrompt
    }, null, 8, ["class"]),
    _createElementVNode("div", _hoisted_1, [
      (_unref(gameStore).status === _unref(GameStatus).InProgress)
        ? (_openBlock(), _createBlock(_unref(Vue3autocounter), {
            key: 0,
            class: _normalizeClass({
          'game-form__counter': true,
          running: _unref(gameStore).roundStatus === _unref(RoundStatus).RUNNING
        }),
            ref_key: "currentRoundCountdown",
            ref: currentRoundCountdown,
            startAmount: 60,
            endAmount: 0.0,
            duration: 60,
            decimals: 2,
            decimalSeparator: ":",
            autoinit: false,
            onFinished: _cache[0] || (_cache[0] = ($event: any) => (roundCountdownExpired()))
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, null, 512),
      _createElementVNode("button", {
        type: "submit",
        class: "primary-button",
        disabled: 
          _unref(gameStore).roundStatus === _unref(RoundStatus).SUBMITTED ||
          _unref(gameStore).userInput === ''
        
      }, [
        _createTextVNode(_toDisplayString(!_unref(isPhone)() ? 'Generate' : '') + " ", 1),
        _createVNode(IconComponent, null, {
          default: _withCtx(() => [
            _createVNode(IconMagicWand)
          ]),
          _: 1
        })
      ], 8, _hoisted_3)
    ])
  ], 32))
}
}

})